module.exports = __webpack_public_path__ + "static/img/1.ab0e19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/color/color-3/1.png
// module id = n2Jb
// module chunks = 36